import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { ComponentAlsphereComponent } from './component.alsphere/component.alsphere.component';
import { PageEmbedAgentComponent } from './page.embed.agent/page.embed.agent.component';
import { PageDashboard2Component } from './page.dashboard2/page.dashboard2.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { ComponentChatbotRemoteComponent } from './component.chatbot.remote/component.chatbot.remote.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { LayoutDashboard2Component } from './layout.dashboard2/layout.dashboard2.component';
import { PortalFabChatComponent } from './portal.fab.chat/portal.fab.chat.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageChatbotEmbedComponent } from './page.chatbot.embed/page.chatbot.embed.component';
import { PageAgentComponent } from './page.agent/page.agent.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageKnowledgeDocument_resultsComponent } from './page.knowledge.document_results/page.knowledge.document_results.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageMypageComponent,
        PagePostsItemComponent,
        ComponentAlsphereComponent,
        PageEmbedAgentComponent,
        PageDashboard2Component,
        PortalSeasonFormDropdownComponent,
        ComponentChatbotRemoteComponent,
        PageMembersComponent,
        LayoutDashboard2Component,
        PortalFabChatComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalPostListComponent,
        PortalSeasonPaginationComponent,
        LayoutSidebarComponent,
        PageDashboardComponent,
        PortalSeasonModalComponent,
        ComponentNavSidebarComponent,
        LayoutEmptyComponent,
        PageChatbotEmbedComponent,
        PageAgentComponent,
        PageAccessComponent,
        PortalSeasonLoadingDefaultComponent,
        PagePostsComponent,
        PageKnowledgeDocument_resultsComponent,
        PortalPostDetailComponent,
        PortalSeasonTreeComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
